module.exports = __webpack_public_path__ + "img/blue_white.937b3d12.jpg";